import React from "react";

export const euroFormat = (value) => {
    return Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: 'EUR'
    }).format(value)
}
